// extracted by mini-css-extract-plugin
export default {"container":"styles_container__E+r-x","text":"styles_text__nrKop","emptyList":"styles_emptyList__s7+Eh","listContainer":"styles_listContainer__k8l8U","center":"styles_center__VA5yF"};